// extracted by mini-css-extract-plugin
export default {"imgZoom":"imgZoom_PEgzr"};